module.exports = __webpack_public_path__ + "src/assets/img/progroup-3.696c6425.png";